// used to export to excel DT with complex headers
export const customExcel = (xlsx: any): void => {
    //copy _createNode function from source
    function _createNode(doc, nodeName, opts) {
        const tempNode = doc.createElement(nodeName);

        if (opts) {
            if (opts.attr) {
                $(tempNode).attr(opts.attr);
            }

            if (opts.children) {
                $.each(opts.children, function (key, value) {
                    tempNode.appendChild(value);
                });
            }

            if (opts.text !== null && opts.text !== undefined) {
                tempNode.appendChild(doc.createTextNode(opts.text));
            }
        }

        return tempNode;
    }

    const sheet = xlsx.xl.worksheets['sheet1.xml'];
    const mergeCells = $('mergeCells', sheet);
    mergeCells[0].children[0].remove(); // remove merge cell 1st row

    const rows = $('row', sheet);
    rows[0].children[0].remove(); // clear header cell

    // create new cell
    rows[0].appendChild(
        _createNode(sheet, 'c', {
            attr: {
                t: 'inlineStr',
                r: 'B1', //address of new cell
                s: 51, // center style - https://www.datatables.net/reference/button/excelHtml5
            },
            children: {
                row: _createNode(sheet, 'is', {
                    children: {
                        row: _createNode(sheet, 't', {
                            text: ' ',
                        }),
                    },
                }),
            },
        })
    );

    // set new cell merged
    mergeCells[0].appendChild(
        _createNode(sheet, 'mergeCell', {
            attr: {
                ref: 'B1:E1', // merge address
            },
        })
    );

    mergeCells.attr('count', mergeCells.attr('count') + 1);

    // add another merged cell
};

export const getExcelExportOptions = (
    title: string,
    tableId: string,
    options?: {
        flatten?: boolean;
        isSummable?: boolean;
        columnLabels?: string[];
        leafNodeClass?: string | string[];
        leafNodeIdentifier?: (row: any) => boolean;
        totalRowIdentifier?: (row: any) => boolean;
        fieldMapping?: { label?: string; level1?: string; level2?: string };
        sortOrder?: string[];
    }
) => {
    return {
        extend: 'excelHtml5',
        title: title,
        exportOptions: {
            orthogonal: 'export',
            format: {
                body: (data, row, column, node) => {
                    if (typeof data === 'string') {
                        // Strip HTML
                        const content = data.replace(/<[^>]+>/g, '').trim();
                        // Handle numbers with commas
                        // Remove commas
                        const numeric = content.replace(/,/g, '');
                        // Check if it's a valid number
                        if (numeric !== '' && !isNaN(Number(numeric))) {
                            return Number(numeric);
                        }
                        return content;
                    }
                    return data;
                },
            },
        },
        customize: xlsx => {
            console.log('[Excel Export] customize callback called');

            // --- 1. Add Custom Styles (Red Negative, Thousands, 2 Decimals, Title Yellow) ---
            const styles = xlsx.xl['styles.xml'];
            const $styles = $(styles);
            const $numFmts = $styles.find('numFmts');
            const $cellXfs = $styles.find('cellXfs');
            const $fills = $styles.find('fills');
            const $fonts = $styles.find('fonts');

            // --- Number Format ---
            const formatId = 170;
            const formatCode = '#,##0.00;[Red](#,##0.00)';
            const countFmts = parseInt($numFmts.attr('count')) + 2; // +2 for decimal and integer
            $numFmts.attr('count', countFmts);
            $numFmts.append(
                `<numFmt numFmtId="${formatId}" formatCode="${formatCode}"/>`
            );

            // --- Integer Format ---
            const integerFormatId = 171;
            const integerFormatCode = '#,##0;[Red](#,##0)';
            $numFmts.append(
                `<numFmt numFmtId="${integerFormatId}" formatCode="${integerFormatCode}"/>`
            );

            // --- Number Style ---
            let countXfs = parseInt($cellXfs.attr('count'));
            // We need to increment count for each new style

            // Style for Numbers (Index: countXfs)
            $cellXfs.append(
                `<xf numFmtId="${formatId}" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/>`
            );
            const customStyleIndex = countXfs;
            countXfs++;

            // Style for Integers (Index: countXfs)
            $cellXfs.append(
                `<xf numFmtId="${integerFormatId}" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/>`
            );
            const integerStyleIndex = countXfs;
            countXfs++;

            // --- Title Style (Yellow, Bold, Center) ---
            // 1. Font (Bold) - Check if exists or create
            // Usually fontId 1 is bold. Let's create a new one to be sure.
            const countFonts = parseInt($fonts.attr('count')) + 1;
            $fonts.attr('count', countFonts);
            $fonts.append(
                '<font><b/><sz val="11"/><color rgb="FF000000"/><name val="Calibri"/></font>'
            );
            const boldFontId = countFonts - 1;

            // 2. Fill Pulse Gold/Yellow #bf9000
            const countFills = parseInt($fills.attr('count')) + 1;
            $fills.attr('count', countFills);
            $fills.append(
                '<fill><patternFill patternType="solid"><fgColor rgb="bf9000"/></patternFill></fill>'
            );
            const yellowFillId = countFills - 1;

            // 3. XF for Title
            $cellXfs.append(
                `<xf numFmtId="0" fontId="${boldFontId}" fillId="${yellowFillId}" borderId="0" xfId="0" applyFont="1" applyFill="1" applyAlignment="1"><alignment horizontal="center"/></xf>`
            );
            const titleStyleIndex = countXfs;
            countXfs++;

            // --- Header Style (Grey #565962, White Text, Bold) ---
            // 1. Font (White, Bold)
            const countFonts2 = parseInt($fonts.attr('count')) + 1;
            $fonts.attr('count', countFonts2);
            $fonts.append(
                '<font><b/><sz val="11"/><color rgb="FFFFFFFF"/><name val="Calibri"/></font>'
            );
            const whiteBoldFontId = countFonts2 - 1;

            // 2. Fill (Grey #565962)
            const countFills2 = parseInt($fills.attr('count')) + 1;
            $fills.attr('count', countFills2);
            $fills.append(
                '<fill><patternFill patternType="solid"><fgColor rgb="FF565962"/></patternFill></fill>'
            );
            const greyFillId = countFills2 - 1;

            // 3. XF for Header
            $cellXfs.append(
                `<xf numFmtId="0" fontId="${whiteBoldFontId}" fillId="${greyFillId}" borderId="0" xfId="0" applyFont="1" applyFill="1" applyAlignment="1"><alignment horizontal="center"/></xf>`
            );
            const headerStyleIndex = countXfs;
            countXfs++;

            // --- Bold Number Style (for Grand Total row) ---
            $cellXfs.append(
                `<xf numFmtId="${formatId}" fontId="${boldFontId}" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" applyFont="1"/>`
            );
            const boldNumberStyleIndex = countXfs;
            countXfs++;

            // --- Bold Integer Style (for Grand Total row) ---
            $cellXfs.append(
                `<xf numFmtId="${integerFormatId}" fontId="${boldFontId}" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" applyFont="1"/>`
            );
            const boldIntegerStyleIndex = countXfs;
            countXfs++;

            $cellXfs.attr('count', countXfs);

            console.log(
                '[Excel Export] Custom styles created. Number:',
                customStyleIndex,
                'Integer:',
                integerStyleIndex,
                'Title:',
                titleStyleIndex,
                'Header:',
                headerStyleIndex,
                'Bold Number:',
                boldNumberStyleIndex,
                'Bold Integer:',
                boldIntegerStyleIndex
            );

            const table = $(tableId).DataTable();
            const settings = table.settings()[0];

            // Helper to check if column is Room Nights
            const isRoomNights = colIdx => {
                const col = settings.aoColumns[colIdx];
                if (!col) return false;
                const header = col.sTitle || $(col.nTh).text();
                const isRnHeader = /^(RN|RNS|nights|Rooms)$/i.test(header);
                const isRnTitle = /Room Nights/i.test(title);
                return isRnHeader || isRnTitle;
            };

            if (options && options.flatten) {
                console.log('[Excel Export] Flatten mode - manipulating XML');

                const sheet = xlsx.xl.worksheets['sheet1.xml'];
                const allRowsData = table.rows().data();

                // Identify columns to skip (e.g. data: 'empty')
                const columnsToSkip = new Set();
                settings.aoColumns.forEach((col, idx) => {
                    if (col.mData === 'empty' || col.sWidth === '1') {
                        columnsToSkip.add(idx);
                    }
                });
                console.log(
                    '[Excel Export] Skipping columns:',
                    Array.from(columnsToSkip)
                );

                // Get the XML worksheet
                const $sheet = $(sheet);
                const $sheetData = $sheet.find('sheetData');
                const $rows = $sheetData.find('row');

                // Header offset
                const headerOffset = 3;

                // Filter: Keep only leaf rows
                // Filter: Keep only leaf rows
                const leafNodeClass = options.leafNodeClass || 'minor-group3-cell';
                const leafClasses = Array.isArray(leafNodeClass)
                    ? leafNodeClass
                    : [leafNodeClass];
                const leafNodeIdentifier = options.leafNodeIdentifier;

                const filteredData = [];
                for (let i = 0; i < allRowsData.length; i++) {
                    const rowObj = allRowsData[i];
                    let isLeaf = false;
                    if (leafNodeIdentifier) {
                        isLeaf = leafNodeIdentifier(rowObj);
                    } else {
                        isLeaf =
                            rowObj && rowObj.aux && leafClasses.includes(rowObj.aux.cls);
                    }

                    if (isLeaf) {
                        // Field Mapping
                        const mapping = options.fieldMapping || {};
                        const labelField = mapping.label || 'label';
                        const level1Field = mapping.level1 || 'level1';
                        const level2Field = mapping.level2 || 'level2';

                        filteredData.push({
                            label: rowObj[labelField],
                            level1: rowObj[level1Field] || '',
                            level2: rowObj[level2Field] || '',
                            rowIndex: i,
                        });
                    }
                }

                // Sort data if sortOrder is provided
                if (options.sortOrder && options.sortOrder.length > 0) {
                    const sortMap = new Map(
                        options.sortOrder.map((label, index) => [label, index])
                    );
                    filteredData.sort((a, b) => {
                        const indexA = sortMap.has(a.label) ? sortMap.get(a.label) : 9999;
                        const indexB = sortMap.has(b.label) ? sortMap.get(b.label) : 9999;
                        return indexA - indexB;
                    });
                }

                // Remove all existing data rows (keep headers)
                $rows.each(function (idx) {
                    if (idx >= headerOffset) {
                        $(this).remove();
                    }
                });

                // Helper: Convert column index to Excel letter
                const getColLetter = colIndex => {
                    let letter = '';
                    let num = colIndex;
                    while (num >= 0) {
                        letter = String.fromCharCode((num % 26) + 65) + letter;
                        num = Math.floor(num / 26) - 1;
                    }
                    return letter;
                };

                // Helper to escape XML special characters
                const escapeXml = (unsafe: any) => {
                    return (unsafe || '')
                        .toString()
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&apos;');
                };

                // Helper: Parse column index from cell reference
                const getColIndex = ref => {
                    const match = ref.match(/^([A-Z]+)/);
                    if (!match) return -1;
                    const letters = match[1];
                    let col = 0;
                    for (let i = 0; i < letters.length; i++) {
                        col = col * 26 + (letters.charCodeAt(i) - 64);
                    }
                    return col - 1;
                };

                // Get columnLabels to determine structure
                const columnLabels = options.columnLabels || [
                    'Sita',
                    'Country',
                    'Region',
                ];

                // Add filtered data rows
                filteredData.forEach((item, idx) => {
                    const newRowNum = headerOffset + idx + 1;
                    const originalRowIndex = item.rowIndex + headerOffset;
                    const $originalRow = $rows.eq(originalRowIndex);

                    if ($originalRow.length) {
                        const $cells = $originalRow.find('c');
                        let newRowXml = `<row r="${newRowNum}">`;

                        const cellMap = new Map();
                        $cells.each(function () {
                            const r = $(this).attr('r');
                            const colIdx = getColIndex(r);
                            cellMap.set(colIdx, $(this));
                        });

                        // 1. Label -> A
                        if (columnLabels.length >= 1) {
                            newRowXml += `<c r="A${newRowNum}" t="inlineStr"><is><t>${escapeXml(
                                item.label
                            )}</t></is></c>`;
                        }

                        // 2. Country/Quarter/Group -> B (only if 2+ columns)
                        if (columnLabels.length >= 2) {
                            newRowXml += `<c r="B${newRowNum}" t="inlineStr"><is><t>${escapeXml(
                                item.level1
                            )}</t></is></c>`;
                        }

                        // 3. Region/Year -> C (only if 3 columns)
                        if (columnLabels.length >= 3) {
                            newRowXml += `<c r="C${newRowNum}" t="inlineStr"><is><t>${escapeXml(
                                item.level2
                            )}</t></is></c>`;
                        }

                        // 4. Data Columns -> start after label columns
                        let maxCol = 0;
                        cellMap.forEach((_, key) => {
                            if (key > maxCol) maxCol = key;
                        });

                        let newColIdx = columnLabels.length; // Start at B (1), C (2), or D (3)
                        for (let c = 2; c <= maxCol; c++) {
                            if (columnsToSkip.has(c)) continue; // Skip empty columns

                            if (cellMap.has(c)) {
                                const $cell = cellMap.get(c);
                                const colLetter = getColLetter(newColIdx);
                                // Apply custom style to numeric cells
                                let cellXml = $cell.prop('outerHTML');

                                // Check if it's a number (t="n" or no t attribute but has value)
                                const type = $cell.attr('t');
                                if (type === 'n' || !type) {
                                    // Inject s="customStyleIndex" or "integerStyleIndex"
                                    const styleToUse = isRoomNights(c)
                                        ? integerStyleIndex
                                        : customStyleIndex;
                                    // Regex to replace existing s="..." or add it
                                    if (cellXml.includes('s="')) {
                                        cellXml = cellXml.replace(
                                            /s="[^"]*"/,
                                            `s="${styleToUse}"`
                                        );
                                    } else {
                                        cellXml = cellXml.replace(
                                            '<c ',
                                            `<c s="${styleToUse}" `
                                        );
                                    }
                                }

                                cellXml = cellXml.replace(
                                    /r="[A-Z]+[0-9]+"/,
                                    `r="${colLetter}${newRowNum}"`
                                );
                                newRowXml += cellXml;
                            }
                            newColIdx++;
                        }

                        newRowXml += '</row>';
                        $sheetData.append(newRowXml);
                    }
                });

                // Update Header Row (Row 3)
                const $headerRow = $rows.eq(2);
                const $headerCells = $headerRow.find('c');
                let headerXml = '<row r="3">';

                const headerCellMap = new Map();
                $headerCells.each(function () {
                    const r = $(this).attr('r');
                    const colIdx = getColIndex(r);
                    headerCellMap.set(colIdx, $(this));
                });

                // 1. Label -> A3

                if (headerCellMap.has(1)) {
                    const $cell = headerCellMap.get(1);
                    // Apply Header Style
                    let cellXml = $cell
                        .prop('outerHTML')
                        .replace(/r="[A-Z]+3"/, `r="A3"`);
                    if (cellXml.includes('s="')) {
                        cellXml = cellXml.replace(/s="[^"]*"/, `s="${headerStyleIndex}"`);
                    } else {
                        cellXml = cellXml.replace('<c ', `<c s="${headerStyleIndex}" `);
                    }
                    headerXml += cellXml;
                } else {
                    headerXml += `<c r="A3" t="inlineStr" s="${headerStyleIndex}"><is><t>${columnLabels[0]}</t></is></c>`;
                }

                // 2. Second column -> B3 (only if we have 2+ labels)
                if (columnLabels.length >= 2) {
                    headerXml += `<c r="B3" t="inlineStr" s="${headerStyleIndex}"><is><t>${columnLabels[1]}</t></is></c>`;
                }

                // 3. Third column -> C3 (only if we have 3 labels)
                if (columnLabels.length >= 3) {
                    headerXml += `<c r="C3" t="inlineStr" s="${headerStyleIndex}"><is><t>${columnLabels[2]}</t></is></c>`;
                }

                // 4. Data Headers -> start after label columns
                let maxHeaderCol = 0;
                headerCellMap.forEach((_, key) => {
                    if (key > maxHeaderCol) maxHeaderCol = key;
                });

                let newHeaderColIdx = columnLabels.length;
                for (let c = 2; c <= maxHeaderCol; c++) {
                    if (columnsToSkip.has(c)) continue;

                    if (headerCellMap.has(c)) {
                        const $cell = headerCellMap.get(c);
                        const colLetter = getColLetter(newHeaderColIdx);
                        let cellXml = $cell
                            .prop('outerHTML')
                            .replace(/r="[A-Z]+3"/, `r="${colLetter}3"`);
                        // Apply Header Style
                        if (cellXml.includes('s="')) {
                            cellXml = cellXml.replace(
                                /s="[^"]*"/,
                                `s="${headerStyleIndex}"`
                            );
                        } else {
                            cellXml = cellXml.replace(
                                '<c ',
                                `<c s="${headerStyleIndex}" `
                            );
                        }
                        headerXml += cellXml;
                    }
                    newHeaderColIdx++;
                }

                headerXml += '</row>';
                $headerRow.replaceWith(headerXml);

                // Add Total row
                const totalRowNum = headerOffset + filteredData.length + 1;
                let totalRowXml = `<row r="${totalRowNum}">`;
                totalRowXml += `<c r="A${totalRowNum}" t="inlineStr" s="2"><is><t>Total</t></is></c>`;
                if (columnLabels.length >= 2) {
                    totalRowXml += `<c r="B${totalRowNum}" s="2"/>`;
                }
                if (columnLabels.length >= 3) {
                    totalRowXml += `<c r="C${totalRowNum}" s="2"/>`;
                }

                // Logic for Total Values
                // If isSummable (default true), use formulas.
                // If NOT summable (e.g. %, Rates), use the value from the Total Row in DataTable.

                const isSummable = options.isSummable; // Default to true
                let totalRowData = null;

                if (!isSummable) {
                    // Find the Grand Total row
                    const totalRowIdentifier = options.totalRowIdentifier;
                    for (let i = 0; i < allRowsData.length; i++) {
                        const row = allRowsData[i];
                        let isTotal = false;
                        if (totalRowIdentifier) {
                            isTotal = totalRowIdentifier(row);
                        } else {
                            isTotal =
                                (row && row.aux && row.aux.cls === 'grand-total-row') ||
                                (row &&
                                    (row.label === 'Total' ||
                                        row.label === 'Grand Total'));
                        }

                        if (isTotal) {
                            totalRowData = row;
                            break;
                        }
                    }
                    console.log(
                        '[Excel Export] Non-summable KPI. Found Total Row:',
                        !!totalRowData
                    );
                }

                // Add values or formulas
                let formulaColIdx = columnLabels.length; // Start at B (1), C (2), or D (3)

                // We need to map the data columns from the Total Row if we are using values.
                // The Total Row has the same data structure as other rows.
                // We need to know which property corresponds to which column.
                // The 'settings.aoColumns' gives us the mData for each column index.

                for (let c = 2; c <= maxHeaderCol; c++) {
                    if (columnsToSkip.has(c)) continue;

                    const col = getColLetter(formulaColIdx);
                    const styleToUse = isRoomNights(c)
                        ? boldIntegerStyleIndex
                        : boldNumberStyleIndex;

                    if (isSummable) {
                        const formula = `SUM(${col}${headerOffset + 1}:${col}${
                            totalRowNum - 1
                        })`;
                        totalRowXml += `<c r="${col}${totalRowNum}" t="n" s="${styleToUse}"><f>${formula}</f></c>`;
                    } else {
                        // Use value from totalRowData
                        let cellValue = 0;
                        if (totalRowData) {
                            // Get mData for this column index (c)
                            const colDef = settings.aoColumns[c];
                            const mData = colDef.mData;
                            if (typeof mData === 'string') {
                                cellValue = totalRowData[mData];
                            } else if (typeof mData === 'function') {
                                // If it's a function, we might need to call it?
                                // Usually for export we rely on the data object.
                                // Let's assume simple property access for now as per fe-sita structure.
                            }

                            // Handle formatting (divide by 1000 if needed?)
                            // The render function handles /1000 for display.
                            // But here we are accessing raw data.
                            // Wait, the raw data in DataTable is usually full numbers.
                            // The render function does the division.
                            // But for export, we want full numbers.
                            // So taking raw data is correct.
                        }

                        // Ensure it's a number
                        const numValue = Number(cellValue) || 0;
                        totalRowXml += `<c r="${col}${totalRowNum}" t="n" s="${styleToUse}"><v>${numValue}</v></c>`;
                    }

                    formulaColIdx++;
                }

                totalRowXml += '</row>';
                $sheetData.append(totalRowXml);

                // --- Auto Filter ---
                // Range: A3 : LastCol LastRow
                const lastColLetter = getColLetter(newHeaderColIdx - 1);
                const filterRef = `A3:${lastColLetter}${totalRowNum}`;

                // Add autoFilter to worksheet
                // Correct Order: sheetData -> autoFilter -> mergeCells -> pageMargins
                // We should insert autoFilter AFTER sheetData
                if ($sheet.find('autoFilter').length === 0) {
                    $sheetData.after(`<autoFilter ref="${filterRef}"/>`);
                } else {
                    $sheet.find('autoFilter').attr('ref', filterRef);
                }

                // --- Column Widths ---
                // Add <cols> definition
                // We have newHeaderColIdx columns total (0 to newHeaderColIdx-1)
                // Let's set a default width
                let colsXml = '<cols>';
                for (let i = 0; i < newHeaderColIdx; i++) {
                    // A, B, C (0,1,2) -> wider
                    const width = i < 3 ? 20 : 15;
                    colsXml += `<col min="${i + 1}" max="${i + 1}" width="${width}" customWidth="1"/>`;
                }
                colsXml += '</cols>';
                // <cols> must be before <sheetData>
                if ($sheet.find('cols').length === 0) {
                    $sheetData.before(colsXml);
                } else {
                    $sheet.find('cols').replaceWith(colsXml);
                }

                // --- Remove Empty 1st Row ---
                // Check Row 1
                const $row1 = $rows.eq(0); // Title row
                if ($row1.children().length === 0) {
                    $row1.remove();
                }

                // --- Title Styling & Date (Row 1) ---
                const $row1_title = $rows.eq(0); // Re-fetch in case it was removed or for clarity
                if ($row1_title.length) {
                    const $a1 = $row1_title.find('c[r="A1"]');
                    if ($a1.length) {
                        // Apply style
                        if ($a1.attr('s')) {
                            $a1.attr('s', titleStyleIndex);
                        } else {
                            $a1.attr('s', titleStyleIndex);
                        }
                    }

                    // Add Date/Time Columns
                    // Last Col = newHeaderColIdx - 1
                    // Date Label = Last Col - 1
                    // Date Value = Last Col

                    const dateLabelColIdx = newHeaderColIdx - 2;
                    const dateValueColIdx = newHeaderColIdx - 1;

                    if (dateLabelColIdx > 0) {
                        const dateLabelLetter = getColLetter(dateLabelColIdx);
                        const dateValueLetter = getColLetter(dateValueColIdx);

                        // Current Date Time
                        const now = new Date();
                        const dateStr =
                            now.toLocaleDateString() + ' ' + now.toLocaleTimeString();

                        // Append cells to Row 1
                        // Note: We need to ensure they are in order.
                        // Since A1 is likely the only cell, appending is fine.
                        $row1_title.append(
                            `<c r="${dateLabelLetter}1" t="inlineStr" s="${titleStyleIndex}"><is><t>File Generated</t></is></c>`
                        );
                        $row1_title.append(
                            `<c r="${dateValueLetter}1" t="inlineStr" s="${titleStyleIndex}"><is><t>${dateStr}</t></is></c>`
                        );

                        // Merge Title: A1 to (DateLabel - 1)
                        const mergeEndColIdx = dateLabelColIdx - 1;

                        // Only merge if we have a valid range (Start < End)
                        // A1 is col 0. mergeEndColIdx must be > 0.
                        if (mergeEndColIdx > 0) {
                            const mergeEndLetter = getColLetter(mergeEndColIdx);
                            const mergeRef = `A1:${mergeEndLetter}1`;

                            // Check if mergeCells exists
                            const $mergeCells = $sheet.find('mergeCells');

                            // If it exists, we should probably clear it or check if we are duplicating.
                            // Since we are in flatten mode and we removed rows, existing merges (if any) might be invalid.
                            // Let's clear and recreate to be safe and ensure correct order.
                            if ($mergeCells.length) {
                                $mergeCells.remove();
                            }

                            // Create new mergeCells element
                            // Correct Order: sheetData -> autoFilter -> mergeCells -> pageMargins
                            const $autoFilter = $sheet.find('autoFilter');
                            const mergeXml = `<mergeCells count="1"><mergeCell ref="${mergeRef}"/></mergeCells>`;

                            if ($autoFilter.length) {
                                $autoFilter.after(mergeXml);
                            } else {
                                $sheetData.after(mergeXml);
                            }
                        }
                    }
                }

                console.log('[Excel Export] Advanced customization complete');
            } else {
                // Standard Indentation Logic for Flat Tables (e.g. pu-day)
                // We do NOT call customExcel() here because it enforces a specific layout (B1 title)
                // that conflicts with the standard "Yellow Title at A1" look we want.

                const table = $(tableId).DataTable();
                const dtRows = table.rows().nodes();
                const $sheet = $(xlsx.xl.worksheets['sheet1.xml']);
                const $sheetData = $sheet.find('sheetData');
                const $rows = $sheetData.find('row');

                // Helper: Convert column index to Excel letter
                const getColLetter = colIndex => {
                    let letter = '';
                    let num = colIndex;
                    while (num >= 0) {
                        letter = String.fromCharCode((num % 26) + 65) + letter;
                        num = Math.floor(num / 26) - 1;
                    }
                    return letter;
                };

                // 1. Apply Title Style (Row 1 / Index 0) and add timestamp
                // DataTable default export puts title in Row 1 (A1 merged).
                const $row1 = $rows.eq(0);
                if ($row1.length) {
                    $row1.find('c').attr('s', titleStyleIndex);

                    // Add "File Generated" timestamp
                    const now = new Date();
                    const dateStr =
                        now.toLocaleDateString() + ' ' + now.toLocaleTimeString();

                    // Find the last column in the sheet to place timestamp
                    let maxCol = 0;
                    $rows.each(function () {
                        $(this)
                            .find('c')
                            .each(function () {
                                const r = $(this).attr('r');
                                const match = r.match(/^([A-Z]+)/);
                                if (match) {
                                    const letters = match[1];
                                    let col = 0;
                                    for (let i = 0; i < letters.length; i++) {
                                        col = col * 26 + (letters.charCodeAt(i) - 64);
                                    }
                                    if (col > maxCol) maxCol = col;
                                }
                            });
                    });

                    // Place timestamp in last two columns
                    const dateLabelCol = getColLetter(maxCol - 1);
                    const dateValueCol = getColLetter(maxCol);

                    $row1.append(
                        `<c r="${dateLabelCol}1" t="inlineStr" s="${titleStyleIndex}"><is><t>File Generated</t></is></c>`
                    );
                    $row1.append(
                        `<c r="${dateValueCol}1" t="inlineStr" s="${titleStyleIndex}"><is><t>${dateStr}</t></is></c>`
                    );
                }

                // 2. Apply Header Style (Row 2 & 3 / Index 1 & 2)
                // We assume headers follow the title.
                // pu-day has 2 header rows.

                // Row 2 (Index 1) is definitely header.
                const $row2 = $rows.eq(1);
                if ($row2.length) {
                    $row2.find('c').attr('s', headerStyleIndex);
                }

                // Row 3 (Index 2) might be header or data.
                const $row3 = $rows.eq(2);
                let headerRowCount = 2;
                if ($row3.length) {
                    const firstCellType = $row3.find('c').first().attr('t');
                    if (firstCellType === 'inlineStr' || firstCellType === 's') {
                        $row3.find('c').attr('s', headerStyleIndex);
                        headerRowCount = 3;
                    }
                }

                // 3. Add AutoFilter to header rows
                // Find the range for AutoFilter (from first header row to last data row)
                const headerRowIndex = headerRowCount; // 1-based (row 3 if we have 2 header rows)
                const lastDataRowIndex = $rows.length; // 1-based

                // Find the last column
                let maxCol = 0;
                $rows.each(function () {
                    $(this)
                        .find('c')
                        .each(function () {
                            const r = $(this).attr('r');
                            const match = r.match(/^([A-Z]+)/);
                            if (match) {
                                const letters = match[1];
                                let col = 0;
                                for (let i = 0; i < letters.length; i++) {
                                    col = col * 26 + (letters.charCodeAt(i) - 64);
                                }
                                if (col > maxCol) maxCol = col;
                            }
                        });
                });

                const lastColLetter = getColLetter(maxCol - 1);
                const filterRef = `A${headerRowIndex}:${lastColLetter}${lastDataRowIndex}`;

                // Add autoFilter to worksheet
                if ($sheet.find('autoFilter').length === 0) {
                    $sheetData.after(`<autoFilter ref="${filterRef}"/>`);
                } else {
                    $sheet.find('autoFilter').attr('ref', filterRef);
                }

                // 4. Apply Data Styles (Red Negative) & Indentation
                let offset = 2; // Minimum (Title + 1 Header)
                if (headerRowCount === 3) {
                    offset = 3; // Title + 2 Headers
                }

                // Find the last row (Grand Total)
                const lastDataRowDtIndex = dtRows.length - 1;

                for (let i = 0; i < dtRows.length; i++) {
                    const dtRow = dtRows[i];
                    const $dtRow = $(dtRow);
                    const excelRowIndex = i + offset;
                    const excelRow = $rows[excelRowIndex];

                    if (excelRow) {
                        const $excelRow = $(excelRow);
                        const $cells = $('c', excelRow);
                        const $labelCell = $cells.eq(0); // Column A

                        // Check if this is the Grand Total row (last row)
                        const isGrandTotal = i === lastDataRowDtIndex;

                        // Apply Red Negative Style (or Bold for Grand Total) to numeric cells
                        $cells.each(function () {
                            const type = $(this).attr('t');
                            // If it's a number (type 'n' or missing type but has value)
                            if (type === 'n' || !type) {
                                const r = $(this).attr('r');
                                const match = r.match(/^([A-Z]+)/);
                                let colIdx = 0;
                                if (match) {
                                    const letters = match[1];
                                    for (let k = 0; k < letters.length; k++) {
                                        colIdx =
                                            colIdx * 26 + (letters.charCodeAt(k) - 64);
                                    }
                                    colIdx--; // 0-based
                                }

                                const isRn = isRoomNights(colIdx);

                                if (isGrandTotal) {
                                    $(this).attr(
                                        's',
                                        isRn
                                            ? boldIntegerStyleIndex
                                            : boldNumberStyleIndex
                                    );
                                } else {
                                    $(this).attr(
                                        's',
                                        isRn ? integerStyleIndex : customStyleIndex
                                    );
                                }
                            }
                        });

                        // Indentation Logic
                        if ($dtRow.hasClass('minor-group-row')) {
                            const $t = $labelCell.find('t');
                            if ($t.length) $t.text('    ' + $t.text());
                        } else if ($dtRow.hasClass('minor-group2-row')) {
                            const $t = $labelCell.find('t');
                            if ($t.length) $t.text('        ' + $t.text());
                        }
                    }
                }
            }
        },
    };
};
